import React, { useState } from "react";

import { Image } from "react-bootstrap";
import { IoIosArrowForward } from "react-icons/io";
import { RiArrowRightDoubleLine } from "react-icons/ri";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { QuizAPI } from "../../Api/Quiz";
import Carousel from "../../Components/Carousel";
import ContentContainer from "../../Components/Container/ContentContainer";
import SectionContainer from "../../Components/Container/SectionContainer";
import {
  Description,
  Header,
  LabelHeader,
  SubHeadline
} from "../../Components/CustomComponent";
import EmptyContainer from "../../Components/CustomComponent/EmptyContainer";
import ContentLoader from "../../Components/Loader/ContentLoader";
import { QUIZ_STATUS, WEB_ROUTES } from "../../constants";
import { useAppContext } from "../../Context/AppContext";
import styles from "./index.module.scss";

export default function Quiz() {
  const navigate = useNavigate();
  const quizAPI = QuizAPI();
  const { SelectQuiz } = useAppContext();
  const [page, setPage] = useState(1);

  const handleNavigate = (route, state) => {
    navigate(`/${route}`, { state: state });
  };

  const {
    data: quizzes,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["quizzes"],
    queryFn: async () => {
      const params = {
        status: QUIZ_STATUS.UPCOMING,
        page: page,
        limit: 10,
      };
      const response = await quizAPI.getQuizzes(params);
      return response.data;
    },
  });

  return (
    <div className={styles.Quiz}>
      <SectionContainer classes={`${styles.container} mx-auto`}>
        <ContentContainer classes="p-4 d-flex flex-column gap-35">
          <div
            className="d-flex flex-row align-items-center justify-content-between gap-2 cursor-pointer"
            onClick={() => handleNavigate(WEB_ROUTES.CREATE_QUIZ)}
          >
            <SubHeadline
              text="Create New Quiz"
              classes="text-uppercase fw-bold"
            />
            <div className={"d-flex align-items-center "}>
              <RiArrowRightDoubleLine color="white" size={25} />
            </div>
          </div>
          <div
            className="d-flex flex-row align-items-center justify-content-between gap-2 cursor-pointer"
            onClick={() => handleNavigate(WEB_ROUTES.QUESTION_HISTORY)}
          >
            <SubHeadline text="Quiz History" classes="text-uppercase" />
            <div className={"d-flex align-items-center cursor-pointer"}>
              <RiArrowRightDoubleLine color="white" size={25} />
            </div>
          </div>
          <div
            className="d-flex flex-row align-items-center justify-content-between gap-2 cursor-pointer"
            onClick={() => handleNavigate(WEB_ROUTES.TUTORIAL_LOGIN)}
          >
            <SubHeadline text="Join Quiz" classes="text-uppercase" />
            <div className={"d-flex align-items-center cursor-pointer"}>
              <RiArrowRightDoubleLine color="white" size={25} />
            </div>
          </div>
        </ContentContainer>
      </SectionContainer>

      <SectionContainer classes={`${styles.container} my-4 mx-auto`}>
        <Header text="What would you like to play today?" />
        <div className="d-flex flex-row align-items-center justify-content-between mt-2">
          <LabelHeader text="Upcoming Quizzes" classes="fw-light" />
          <LabelHeader
            text="See all"
            classes="fw-light"
            onClick={() => handleNavigate(WEB_ROUTES.QUESTION_HISTORY)}
          />
        </div>
      </SectionContainer>
      {
        !quizzes?.length ? "" :
          <SectionContainer classes={'mx-auto px-sm-0'}>
            <Carousel TOTAL_ITEMS={quizzes} />
          </SectionContainer>
      }

      <SectionContainer
        classes={`${styles.container} d-flex flex-column my-4 gap-3 mx-auto`}
      >
        {isLoading ? (
          <ContentLoader />
        ) : !quizzes?.length ? (
          <EmptyContainer text="No quizzes found" />
        ) : (
          quizzes?.map((item, index) => {
            return (
              <ContentContainer
                key={index}
                bg="#1A2550"
                hasBorder={false}
                classes="p-3 d-flex flex-row gap-3"
              >
                <div className={styles.imageContainer}>
                  <Image
                    src={item?.cover_image_url || "/assets/image-.png"}
                    alt={"Quiz Image " + index}
                    className={styles.image}
                  />
                </div>
                <div
                  className="w-100 d-flex flex-row align-items-center justify-content-between cursor-pointer"
                  onClick={() => {
                    handleNavigate(WEB_ROUTES.QUIZ_HISTORY, {
                      quiz_id: item?.id,
                    });
                    SelectQuiz(item);
                  }}
                >
                  <div className="d-flex flex-column gap-2">
                    <LabelHeader text={item?.title} />
                    <Description
                      text={`${item?.title?.split(" ")[0]} • ${item?.quiz_questions_count
                        } Question(s)`}
                      size="7"
                    />
                  </div>
                  <div className="d-flex align-items-center cursor-pointer">
                    <IoIosArrowForward color="white" size={25} />
                  </div>
                </div>
              </ContentContainer>
            );
          })
        )}
      </SectionContainer>
    </div>
  );
}
